import { SortType, SortMode } from '@intelligence/pages/TopCharts/_config/enums';
import { DATASOURCE_KEY_MAP, SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';

import type { IGameType } from '@intelligence/types/common';
import type { IMobileDetailsOverlapRanksFetchParams } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/types';

export const ENTITY_TYPE: IGameType = 'mobile';

// export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE_SIZE = 50;

export const DEFAULT_FETCH_PARAMS: IMobileDetailsOverlapRanksFetchParams = {
  /* -----页面其他参数----- */
  entity_type: ENTITY_TYPE,
  game_ids: [],
  /* -----页面其他参数----- */

  /* -----筛选器参数----- */
  markets: ['us'],
  genre_source: 'iegg',
  iegg_genre: [],
  sensortower_genre: [],
  appannie_genre: [],
  granularity: 'monthly',
  start_date: '',
  end_date: '',
  mobile_overlap: {
    opt: '',
    value: Number.NaN,
  },
  /* -----筛选器参数----- */

  /* -----排序、分页参数----- */
  order_source: DATASOURCE_KEY_MAP.SENSORTOWER,
  order_metric: SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE,
  order: SortType.Desc,
  ratio_type: SortMode.Value, // 环比排序是1 ，默认值排序是0
  page: 1,
  // page_size: 100,
  page_size: 50,
  /* -----排序、分页参数----- */

  /* -----搜索参数----- */
  search_by_name: '',
  search_by_ids: [],
  /* -----搜索参数----- */
};
